<script>
export default {
  props: {
    menu: {
      type: Array,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      role: [],
      listCode: this.code,
      checkedList: [],
      permission: null,
    }
  },
  watch: {
    permission(oldVal, newVal) {
      this.permission.map((Item) => {
        var listIndex = this.checkedList.findIndex((obj) => obj === Item.code)

        this.setactions(Item)
        if (listIndex === -1) {
          document.getElementById(Item.code).checked = true
          this.checkedList.push(Item.code)
        }
        if (Item.children !== undefined)
          if (Item.children.length > 0) {
            this.checkChildren(Item)

            this.getChild(Item.code, Item.children)
          }
        // this.checkChildren(Item.attributes.children)

        //

        //   if(listIndex===-1){

        // this.checkedList.push(Item.attributes.code)

        //    }
      })
      this.role = this.permission
    },
  },
  mounted() {
    var parent = this
    this.$root.$on('children', function(data) {
      if (data.code !== undefined) {
        if (data.code === parent.listCode) {
          parent.permission = data.children
          parent.role = data.children
        }
      }
    })
  },
  methods: {
    getChild(listCode, children) {
      var parent = this
      setTimeout(() => {
        var data = { code: listCode, children: children }

        parent.$root.$emit('children', data)
      }, 800)
    },
    checkChildren(Item) {
      if (Item.children.length > 0)
        Item.children.map((Items) => {
          // var listIndex=this.checkedList.findIndex((obj=>obj===Item.attributes.code))
          setTimeout(() => {
            document.getElementById(Items.code).checked = true
            this.setactions(Items)
          }, 400)
        })
    },
    sendChildren(list) {
      if (this.permission.length > 0) {
        var index = this.permission.findIndex((obj) => obj.code === list.code)
        if (index !== -1) {
          if (this.permission[index].children.length > 1)
            return this.permission[index].children.length > 1
          else return []
        }
      }
    },
    setactions(Item) {
      setTimeout(() => {
        Item.actions.forEach((element) => {
          document.getElementById(Item.code + element).checked = true
        })
      }, 1000)
    },
    checkListChecked(check) {
      var listIndex = this.checkedList.findIndex((obj) => obj === check)
      if (listIndex !== -1) {
        return true
      } else {
        return false
      }
    },

    getData(list) {
      var listIndex = this.checkedList.findIndex((obj) => obj === list.code)
      if (listIndex !== -1) {
        this.checkedList.splice(listIndex, 1)
      } else {
        this.checkedList.push(list.code)
      }
      var objIndex = this.role.findIndex((obj) => obj.code === list.code)
      if (objIndex !== -1)
        if (!document.getElementById(list.code).checked)
          this.role.splice(objIndex, 1)

      this.$emit('update', this.role)
    },
    getChildren(data, list) {
      if (this.role.length < 1) {
        this.role.push({
          code: list.code,
          children: data,
          actions: [],
        })
      } else {
        var objIndex = this.role.findIndex((obj) => obj.code === list.code)
        if (objIndex !== -1) {
          this.role[objIndex].children = data
        } else {
          this.role.push({
            code: list.code,
            children: data,
            actions: [],
          })
        }
      }

      this.$emit('update', this.role)
    },
    getAction(actions, list) {
      //  console.log(list)

      if (this.role.length < 1) {
        this.role.push({
          code: list.code,
          children: [],
          actions: [actions],
        })
      } else {
        var objIndex = this.role.findIndex((obj) => obj.code === list.code)
        if (objIndex !== -1) {
          var x = this.role[objIndex].actions.indexOf(actions)
          if (document.getElementById(list.code + actions).checked) {
            if (x === -1) {
              this.role[objIndex].actions.push(actions)
            }
          } else {
            if (x !== -1) {
              this.role[objIndex].actions.splice(x, 1)
            }
          }
        } else {
          if (document.getElementById(list.code + actions).checked) {
            this.role.push({
              code: list.code,
              children: [],
              actions: [actions],
            })
          }
        }
      }

      this.$emit('children', this.role)
    },
  },
}
</script>
<template>
  <div>
    <ul v-if="menu" class="" :class="$style.rolesListing">
      <li
        v-for="(list, key) in menu"
        :key="key + list.code"
        class="p15 pr0"
        :class="$style.roleListingChild"
      >
        <label :class="$style.rolesParentName"
          >{{ list.title }}
          <input
            :id="list.code"
            type="checkbox"
            :name="list.code"
            :value="list.code"
            @click="getData(list)"
          />
          <span :class="$style.checkmark"></span>
        </label>
        <ul
          v-if="checkListChecked(list.code)"
          class=""
          :class="$style.rolesListing"
        >
          <li
            v-for="(action, key1) in list.actions"
            :key="key1 + list.code"
            :class="$style.roleListingChildInner"
            class="p15 pr0"
          >
            <label :class="$style.rolesParentName"
              >{{ action.name }}
              <input
                :id="list.code + action.codename"
                :name="list.code + action.codename"
                :value="action.codename"
                type="checkbox"
                @click="getAction(action.codename, list)"
              />
              <span :class="$style.checkmark"></span>
            </label>
          </li>

          <StaffBaseRoleManageTreeChild
            v-if="list.children.length > 0"
            :key="list.code"
            :code="list.code"
            :menu="list.children"
            @children="getChildren($event, list)"
          />
        </ul>
      </li>
    </ul>

    <div class="clear"></div>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.rolesListing {
  display: inline-block;

  .roleListingChild {
    position: relative;
    display: block;
    margin-left: 7px;
    border-radius: 5px;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 1px;
      height: 100%;
      content: '';
      background: #d0d0d0;
      border: 1px dashed #fafafa;
    }

    &:last-child::after {
      height: 50%;
    }

    &::before {
      position: absolute;
      top: 24px;
      left: 0;
      width: 100%;
      height: 1px;
      content: '';
      background: #d0d0d0;
      border: 1px dashed #fafafa;
    }
  }

  .roleListingChildInner {
    position: relative;
    display: block;
    margin-left: 7px;
    border-radius: 5px;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 1px;
      height: 100%;
      content: '';
      background: #d0d0d0;
    }

    &:last-child::after {
      height: 50% !important;
    }

    &::before {
      position: absolute;
      top: 24px;
      left: 0;
      width: 100%;
      height: 1px;
      content: '';
      background: #d0d0d0;
    }
  }

  .rolesParentName {
    position: relative;
    display: block;
    padding-left: 29px;
    margin: 0;
    font-family: 'LexendDecaRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 15px;
    color: #8c959f;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background: #fff;

    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 20px;
      height: 20px;
      background-color: #fff;
      border: 1px solid #e7e7e8;
      border-radius: 3px;
      transition: all ease-in-out 0.3s;

      &::after {
        top: 3px;
        left: 11px;
        display: none;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }

    input[type='checkbox'] {
      position: absolute;
      width: 0;
      height: 0;
      cursor: pointer;
      opacity: 0;
    }

    input[type='checkbox']:checked ~ .checkmark {
      background-color: #09f;
      border-color: #09f;
    }

    input[type='checkbox']:checked ~ .checkmark::after {
      display: block !important;
    }

    &:hover {
      input[type='checkbox'] ~ .checkmark {
        background-color: #f8fafb;
        transition: all ease-in-out 0.3s;
      }

      input[type='checkbox']:checked ~ .checkmark {
        background-color: #09f;
        border-color: #09f;
        transition: all ease-in-out 0.3s;
      }
    }
  }
}
</style>
